import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { OAuthStorage } from 'angular-oauth2-oidc';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class StorageService implements OAuthStorage {
  constructor(private cookieService: CookieService) {}

  getItem(key: string): string | null {
    const value = this.cookieService.get(key);
    return value || null;
  }

  removeItem(key: string): void {
    this.cookieService.delete(key, '/espace-client');
  }

  setItem(key: string, data: string): void {
    const shouldSecure = environment.target !== 'local';
    this.cookieService.set(
      key,
      data,
      undefined,
      '/espace-client',
      undefined,
      shouldSecure,
      'Strict',
    );
  }
}
